export { default } from './EnterDetailsScreen';